import React from 'react';

interface HamburgerMenuIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

/**
 * HamburgerMenuIcon Component
 * 
 * A three-line menu icon (hamburger menu).
 * 
 * @component
 * @example
 * ```tsx
 * <HamburgerMenuIcon size={24} color="#111827" />
 * ```
 */
export const HamburgerMenuIcon: React.FC<HamburgerMenuIconProps> = ({ 
  size = 24, 
  color = '#111827',
  ...props 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    fill="none" 
    viewBox="0 0 24 24"
    {...props}
  >
    <path 
      stroke={color} 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth={2} 
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
);

export default HamburgerMenuIcon;

